/**
 * Handwriting mode: when the storefront is loaded with handwriting=true in the URL,
 * we set a global flag so components can hide quantity/price and avoid passing
 * quantity to the designer. The router adds handwriting=true to the URL on navigation
 * so it persists (e.g. on PDP and on refresh).
 *
 * Works in both contexts:
 * - Capacitor embed (capacitor=true&handwriting=true): same UX, back/restore via iframe.
 * - Regular web (handwriting=true only): same UX, normal browser navigation.
 */
export const HANDWRITING_FLAG = "__EXPRESS_HANDWRITING__";

export default function handwritingModePlugin() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  if (params.get("handwriting") === "true") {
    window[HANDWRITING_FLAG] = true;
  }
}
